export enum HistoryRewardType {
    'CONTEST' =' CONTEST',
    'CATALOG' = 'CATALOG',
    'CATALOG_LOYALTY_COLLECTION' = 'CATALOG_LOYALTY_COLLECTION',
    'CATALOG_DIGITAL_WALLET' = 'CATALOG_DIGITAL_WALLET',
    'ALL' = 'ALL',
}

export enum HistoryRewardTypeCustom {
    'CONTEST' ='contest',
    'CATALOG' = 'catalog',
    'CATALOG_LOYALTY_COLLECTION' = 'loyalty-collection',
    'CATALOG_DIGITAL_WALLET' = 'digital-wallet'
}